import { render, staticRenderFns } from "./EditCategoryPopup.vue?vue&type=template&id=0b7942e3&"
import script from "./EditCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./EditCategoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports